import axios from "axios";
const currentLang = document.documentElement.lang;
const lang = "pl";

const URL = process.env.REACT_APP_API_URL;
const newURL = `${URL}/profile/?lang=${lang}`;

export interface ICalculationField {
  defautValue?: number;
  name: string;
  shortName: string;
  value?: number;
}
export interface IProfileResponse {
  calculationFields: ICalculationField[];
  iconUrl: string;
  id: string;
  imageUrl: string;
  name: string;
  profileType: string;
}

export const profileServices = () => {
  return axios.get<IProfileResponse[]>(newURL);
};
